import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, withStyles, BodyText } from 'vopay';
import { Title, CircleButton, Button } from 'UI';
import styles from './UpgradePlanBankDialog.module.scss';
import { useTranslation } from 'react-i18next';

type UpgradePlanBankDialogProps = {
  onCancel: () => void;
};

const cn = withStyles(styles);

const UpgradePlanBankDialog: FC<UpgradePlanBankDialogProps> = ({ onCancel }) => {
  const history = useHistory();
  const { t } = useTranslation('translations', {
    keyPrefix: 'Customers.PaymentMethodsTab.Details.Verification.UpgradePlanBankDialog',
  });

  return (
    <Card className={cn('modalContainer')}>
      <Title level="3" className={cn('title')}>
        {t('title', { defaultValue: 'Upgrade Your Plan!' })}
      </Title>

      <div className={cn('closeButton')}>
        <CircleButton icon="close" size="large" circleFill onClick={onCancel} />
      </div>

      <BodyText className={cn('description')}>
        {t('description', {
          defaultValue: 'Verify the ownership of the Bank Account.',
        })}
      </BodyText>

      <Button
        className={cn('button')}
        colorScheme="primary"
        onClick={() => {
          onCancel();
          history.push({
            pathname: '/create-tickets',
            state: {
              ticketSubject: t('ticketSubject', { defaultValue: 'Enquiry about Microdeposit Bank Verification.' }),
            },
          });
        }}
      >
        {t('contactSupportButton', { defaultValue: 'Contact Support' })}
      </Button>
    </Card>
  );
};

export default UpgradePlanBankDialog;
